/**
 * Created by huangzhangshu on 2018/8/6
 */
import http from '../utils/http';

export async function login(params) {
  const {username, password} = params;
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);
  formData.append('type', 'account');
  return http.postForm('login', formData);
}


export async function fetchLicense() {
  return http.getStatic('static/resources/licInfo.json');
}

export async function fetchSetting() {
  return http.getStatic('static/resources/setting.json');
}



// WEBPACK FOOTER //
// ./src/services/login.js